import { render, staticRenderFns } from "./CollectionWidgetsSelections.vue?vue&type=template&id=f7ad58b8&scoped=true"
import script from "./CollectionWidgetsSelections.vue?vue&type=script&lang=js"
export * from "./CollectionWidgetsSelections.vue?vue&type=script&lang=js"
import style0 from "./CollectionWidgetsSelections.vue?vue&type=style&index=0&id=f7ad58b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ad58b8",
  null
  
)

export default component.exports